<template>
    <main class="smaller-padding data-table">
        <app-integration-report-modal></app-integration-report-modal>

        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            :hide-actions="true"
            :must-sort="true"
            :no-data-text="$t('message.generics.message.noData')"
            :no-results-text="$t('message.generics.message.noData')"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <app-integration-table-item
                    :data-item="props.item"
                    @reload="reloadTable"
                ></app-integration-table-item>
            </template>
        </v-data-table>
    </main>
</template>

<script>
import EventBus from "@packages/event-bus";
import AppIntegrationTableItem from "./components/IntegrationTableItem";
import AppIntegrationReportModal from "./components/integration-report-modal/IntegrationReportModal";
import provider from "@mixins/provider";

export default {
    components: {
        AppIntegrationTableItem,
        AppIntegrationReportModal,
    },

    data() {
        return {
            loading: false,
            list: [],
        };
    },

    computed: {
        headers() {
            return [
                { text: "", value: "", sortable: false },
                {
                    text: this.$t("message.admGenerics.message.active"),
                    value: "isActive",
                },
                {
                    text: this.$t("message.generics.message.name"),
                    value: "name",
                },
                {
                    text: this.$t("message.generics.message.creationDate"),
                    value: "type",
                },
                {
                    text: this.$t("message.admGenerics.message.edition"),
                    value: "",
                },
            ];
        },
    },

    mixins: [provider],

    methods: {
        async loadIntegrationHandler() {
            this.list = await this.$api.integrationManagement.list();
        },
        reloadTable() {
            this.loadIntegrationHandler();
        },
    },

    async mounted() {
        this.loading = true;
        EventBus.$on("LOAD_INTEGRATION", this.loadIntegrationHandler);
        EventBus.$emit("LOAD_INTEGRATION");
        this.loading = false;
    },

    beforeDestroy() {
        EventBus.$off("LOAD_INTEGRATION", this.loadIntegrationHandler);
    },
};
</script>

<style scoped></style>
